import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from '../api';
import { queryKeys } from '../queryKeys';
import type { Spotcheck } from '../types';

export type SpotcheckInput = {
  ticket_id: number;
  ticket_date?: string;
  tse_name?: string;
};

export function useSpotchecks() {
  return useQuery({
    queryKey: queryKeys.spotchecks,
    queryFn: () => apiRequest<Spotcheck[]>('/api/spotchecks'),
  });
}

export function useCreateSpotcheck() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: SpotcheckInput) => apiRequest<Spotcheck>('/api/spotchecks', { method: 'POST', body: input }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.spotchecks }),
  });
}

export function useUpdateSpotcheck() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: number; patch: Partial<Spotcheck> }) =>
      apiRequest<Spotcheck>(`/api/spotchecks/${id}`, { method: 'PATCH', body: patch }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.spotchecks }),
  });
}

export function useDeleteSpotcheck() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => apiRequest<void>(`/api/spotchecks/${id}`, { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.spotchecks }),
  });
}
